import Env from '../../base/env'
import Channels from '../../base/channels'

export default class Shape
{
    constructor(view)
    {
        // DOM
        this.view = view
        this.$menu = this.view.querySelector('.primary-nav__menu')
        this.$canvas = this.view.querySelector('.jsCanvas')
        // Arrays
        this.rects = []
        // Vars
        this.canvasContext = this.$canvas.getBoundingClientRect()
        this.context = this.$menu.getBoundingClientRect()
        this.viewport = Env.framework.toolbox.getViewport()
        // Pixi
        this.renderer = new PIXI.autoDetectRenderer({width : this.canvasContext.width  , height :this.context.height , transparent: true })
        this.stage = new PIXI.Container()
        this.ticker = new PIXI.ticker.Ticker()
        // Flags
        this.shapeSize = 16
        this.SPEED = 5
        this.IS_ANIMATING = false
        // Fns
        this.funcResize = this.refresh.bind(this)
    }



    drawNoise()
    {

        // CRect 1
        this.rect1 = new PIXI.Graphics();
        this.rect1.beginFill(0x000000);
        this.rect1.drawRect(0, 30, this.canvasContext.width - 50, this.shapeSize);
        this.rect1.alpha = 0
        // this.rect1.x = this.canvasContext.width
        // CRect 2
        this.rect2 = new PIXI.Graphics();
        this.rect2.beginFill(0x000000);
        this.rect2.drawRect(0, 105, this.canvasContext.width - 50, this.shapeSize);
        this.rect2.alpha = 0
        // this.rect2.x = this.canvasContext.width
        // CRect 3
        this.rect3 = new PIXI.Graphics();
        this.rect3.beginFill(0x000000);
        this.rect3.drawRect(0, 178, this.canvasContext.width - 50, this.shapeSize);
        this.rect3.alpha = 0
        // this.rect3.x = this.canvasContext.width
        // Noise
        this.filterNoise = new PIXI.filters.NoiseFilter(.5)
        this.filterNoise.padding = 50
        this.rect1.filters = [this.filterNoise];
        this.rect2.filters = [this.filterNoise];
        this.rect3.filters = [this.filterNoise];

        // Apply
        this.rects.push(this.rect1)
        this.rects.push(this.rect2)
        this.rects.push(this.rect3)
        this.stage.addChild(this.rect1);
        this.stage.addChild(this.rect2);
        this.stage.addChild(this.rect3);
    }

    destroy()
    {
        this.ticker.destroy()
        this.renderer.destroy()
        Channels.removeListener('window::smartresize', this.funcResize);
    }

    events()
    {
        Channels.on('window::smartresize',this.funcResize)
    }

    in(index)
    {
        // TweenLite.to(this.rects[index] , .5 , { x : 0 , ease : Power3.easeOut })
        TweenLite.to(this.rects[index] , .8 , { alpha : .7 , ease : Cubic.easeOut })
    }

    out(index)
    {
        // TweenLite.to(this.rects[index] , .5 , { x : this.canvasContext.width , ease : Power3.easeOut })
        TweenLite.to(this.rects[index] , .8 , { alpha : 0 , ease : Cubic.easeOut })
    }

    refresh()
    {
        this.canvasContext = this.$canvas.getBoundingClientRect()
        this.context = this.$menu.getBoundingClientRect()
        this.viewport = Env.framework.toolbox.getViewport()
        // Stage
        this.renderer.view.style.width = `${this.canvasContext.width}px`
        this.renderer.view.style.height = `${this.context.height}px`
        this.renderer.resize(this.canvasContext.width,this.context.height)
        // Rect1
        this.rect1.clear();
        this.rect1.beginFill(0x000000);
        this.rect1.drawRect(0, 30, this.canvasContext.width - 50, this.shapeSize);
        // Rect2
        this.rect2.clear();
        this.rect2.beginFill(0x000000);
        this.rect2.drawRect(0, 105, this.canvasContext.width - 50, this.shapeSize);
        // Rect3
        this.rect3.clear();
        this.rect3.beginFill(0x000000);
        this.rect3.drawRect(0, 178, this.canvasContext.width - 50, this.shapeSize);
    }

    render()
    {
        this.ticker.add((delta)=>{
            this.filterNoise.seed = Math.random() * delta
            this.renderer.render( this.stage );
        });
    }

    setup()
    {
        this.$canvas.appendChild( this.renderer.view );
        this.drawNoise()
        this.events()
        this.render()
    }

    start()
    {
        this.ticker.start()
    }

    stop()
    {
        this.ticker.stop()
    }

}